import { render, staticRenderFns } from "./TurnoverOverview.vue?vue&type=template&id=04880bf2&"
import script from "./TurnoverOverview.vue?vue&type=script&lang=js&"
export * from "./TurnoverOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports